module.exports = __webpack_public_path__ + "img/cfa7790.png";